var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 40.9399H42",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89941 40.9399L3.99941 16.8799C3.99941 15.6599 4.57941 14.5 5.53941 13.74L19.5395 2.84C20.9795 1.72 22.9993 1.72 24.4593 2.84L38.4595 13.72C39.4395 14.48 39.9995 15.6399 39.9995 16.8799V40.9399",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30.9399H20C18.34 30.9399 17 32.2799 17 33.9399V40.9399H27V33.9399C27 32.2799 25.66 30.9399 24 30.9399Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 24.4399H13C11.9 24.4399 11 23.5399 11 22.4399V19.4399C11 18.3399 11.9 17.4399 13 17.4399H17C18.1 17.4399 19 18.3399 19 19.4399V22.4399C19 23.5399 18.1 24.4399 17 24.4399Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31 24.4399H27C25.9 24.4399 25 23.5399 25 22.4399V19.4399C25 18.3399 25.9 17.4399 27 17.4399H31C32.1 17.4399 33 18.3399 33 19.4399V22.4399C33 23.5399 32.1 24.4399 31 24.4399Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0006 10.9399L35.9406 4.93994H27.1406",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWhite);
export default __webpack_public_path__ + "static/media/home-white.b6e6299baa22f0ca94b771084dd4b360.svg";
export { ForwardRef as ReactComponent };